import gql from 'graphql-tag';
import { ChannelConfiguration, Topic } from '@jupiterone/notification-types';
import { createUseMutationHook } from '@jupiterone/jupiter-web-toolkit';
import { ChannelConfigurationFragment } from './fragments';

export interface SetUserNotificationSettingsForTopicMutationData {
  setUserNotificationSettingsForTopic: ChannelConfiguration;
}

export interface SetUserNotificationSettingsForTopicMutationVariables {
  update: {
    topic: Topic;
    channelConfigurationUpdate: ChannelConfiguration;
  };
}

export const SetUserNotificationSettingsForTopicMutation = gql`
  mutation SetUserNotificationSettingsForTopic(
    $update: SetUserNotificationSettingsForTopicInput!
  ) {
    setUserNotificationSettingsForTopic(update: $update) {
      ...ChannelConfigurationFragment
    }
  }
  ${ChannelConfigurationFragment}
`;

export const useSetUserNotificationSettingsForTopicMutation = createUseMutationHook<
  SetUserNotificationSettingsForTopicMutationData,
  SetUserNotificationSettingsForTopicMutationVariables
>(SetUserNotificationSettingsForTopicMutation);
